import type { FoundationTypeQuoteFormInput } from 'app/home/create-quote/forms/property-details/foundation/foundation.types';
import type { QuoteDraftSelectorState } from 'app/home/global-store/quote-draft';
import type { QuoteFormOptionsSelectorState } from 'app/home/global-store/quote-form-options';

export function foundationTypeQuoteFormSelector(store: QuoteDraftSelectorState): FoundationTypeQuoteFormInput {
  const foundationType = store.foundationType();
  return { foundationType };
}

export function foundationTypeQuoteFormOptionsSelector(store: QuoteFormOptionsSelectorState) {
  return store.foundation();
}
